import * as actions from './main.actions';
import { ActionType as AT } from './enums/action-type.enum';
import { PreloaderState } from './interfaces/preloader-state.interface';

type InferValueTypes<T> = T extends { [key: string]: infer U } ? U : never;
type Action = ReturnType<InferValueTypes<typeof actions>>;

class MainState {
	progressBar = {
		active: false
	};
	preloader:PreloaderState = {
		active: true,
		mode: 'default'
	};
	error?: string;
	serverError?: number;
	phone?:string;
	callTime?:string;
	initialPageIndex: number = 0;
	wasOpened: boolean = false;
}

export const mainReducer = (state = new MainState(), action:Action):MainState => {
	switch (action.type) {
		case AT.UPDATE_PROGRESS_VALUE: {
			return { ...state, progressBar: { ...state.progressBar }};
		}

		case AT.TOGGLE_PROGRESS: {
			return { ...state, progressBar: {...state.progressBar, active: action.payload.status }};
		}

		case AT.SET_ERROR: {
			return {...state, error: action.payload.error};
		}

		case AT.RESET_ERROR: {
			return {...state, error: undefined};
		}

		case AT.TOGGLE_PRELOADER: {
			return { ...state, preloader: {...action.payload} };
		}

		case AT.SHOW_ERROR: {
			return { ...state, serverError: action.payload.code };
		}

		case AT.ADD_PHONE: {
			return { ...state, phone: action.payload.phone };
		}

		case AT.SET_INITIAL_PAGE_INDEX: {
			return { ...state, initialPageIndex: action.payload.index };
		}

		case AT.SET_QUIZ_WAS_OPENED: {
			return { ...state, wasOpened: action.payload.status };
		}

		default: return state;
	}
}